import { render, staticRenderFns } from "./guild.vue?vue&type=template&id=03d952d7"
import script from "./guild.vue?vue&type=script&lang=js"
export * from "./guild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports